import ChatMessageUploadQueue from './ChatMessageUploadQueueContainer';

export default ChatMessageUploadQueue;
